import React from "react";

export default function EthIco() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
        fill="#627EEA"
      />
      <path
        d="M15.4658 3.75V12.0656L22.4943 15.2062L15.4658 3.75Z"
        fill="white"
        fillOpacity="0.602"
      />
      <path
        d="M15.4669 3.75L8.4375 15.2062L15.4669 12.0656V3.75Z"
        fill="white"
      />
      <path
        d="M15.4658 20.5951V26.2455L22.4989 16.5151L15.4658 20.5951Z"
        fill="white"
        fillOpacity="0.602"
      />
      <path
        d="M15.4669 26.2455V20.5942L8.4375 16.5151L15.4669 26.2455Z"
        fill="white"
      />
      <path
        d="M15.4658 19.2873L22.4943 15.2064L15.4658 12.0676V19.2873Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M8.4375 15.2064L15.4669 19.2873V12.0676L8.4375 15.2064Z"
        fill="white"
        fillOpacity="0.602"
      />
    </svg>
  );
}
